module.exports = __webpack_public_path__ + "img/blue_clock.e4accbdf.png";